/*
 *
 * ModeBar constants
 *
 */

enum ActionTypes {
  SWITCH_MODE = 'app/ModeBar/SWITCH_MODE',
  SWITCH_HANDLE_MODE = 'app/ModeBar/SWITCH_HANDLE_MODE',
  APPLY_DELETE = 'app/ModeBar/APPLY_DELETE',
  APPLY_COLOR_HANDLE = 'app/ModeBar/APPLY_COLOR_HANDLES',
}

export default ActionTypes;
